import React, { VFC } from 'react'

import { SanityContact } from '../../../groq/sanity-dispensaries/types'
import { Dispensary } from '../../../lib/dispensaries'
import { DispensaryContactCardContent } from './DispensaryContactCardContent'
import * as Styled from './styled'

import graphicOrangeBlue from '../../../img/color-waves-orange-blue.svg'

export interface DispensaryContactCardProps {
  className?: string
  dispensary: Pick<Dispensary, 'name' | 'slug'>
  contact?: SanityContact | null
  graphicSrc?: string
  clickableLinks?: boolean
}

export const DispensaryContactCard: VFC<DispensaryContactCardProps> = ({
  className,
  dispensary,
  contact,
  graphicSrc,
  clickableLinks,
}) => (
  <Styled.DispensaryCardContained
    className={className}
    backgroundGraphic={graphicSrc ?? graphicOrangeBlue}
  >
    <DispensaryContactCardContent
      dispensary={dispensary}
      contact={contact}
      clickableLinks={clickableLinks}
    />
  </Styled.DispensaryCardContained>
)

export const DispensaryContactCardFluid: VFC<DispensaryContactCardProps> = ({
  className,
  dispensary,
  contact,
  graphicSrc,
  clickableLinks,
}) => (
  <Styled.DispensaryCardFluid
    className={className}
    backgroundGraphic={graphicSrc ?? graphicOrangeBlue}
  >
    <DispensaryContactCardContent
      dispensary={dispensary}
      contact={contact}
      clickableLinks={clickableLinks}
    />
  </Styled.DispensaryCardFluid>
)
